import { render, staticRenderFns } from "./analiz.vue?vue&type=template&id=2c0c4294&"
import script from "./analiz.vue?vue&type=script&lang=js&"
export * from "./analiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports